import React, { memo } from "react";
import { Box } from "@mui/material";
import { Icon } from "../../Icon";
import { buildMenuStructure } from "./helpers";
import Sidebar from "./Sidebar";
import SidebarItem from "./SidebarItem";
import SidebarItems from "./SidebarItems";
import SidebarSection from "./SidebarSection";
const MenuSectionDivider = () => (React.createElement(Box, { sx: {
        marginTop: 3,
        marginBottom: 3,
    } }));
const GlobalSidebar = ({ currentServiceId, customMenuForCurrentService, footerMenu, services, showCollapseButton, sx, linkComponent, }) => {
    const menuList = buildMenuStructure(services);
    return (React.createElement(Sidebar, { sx: sx, showCollapseButton: showCollapseButton },
        React.createElement(SidebarSection, null,
            React.createElement(SidebarItem, { sx: {
                    root: {
                        marginTop: 0,
                        marginBottom: 4,
                    },
                    listButton: {
                        "&:hover, &:focus": {
                            backgroundColor: "transparent",
                        },
                    },
                    buttonLabel: {
                        fontSize: "18px",
                        fontWeight: 400,
                    },
                }, to: "", selected: false, isParent: true, label: "CP Hub", icon: React.createElement(Icon, { name: "cpLogo" }), linkComponent: linkComponent, ListItemButtonProps: {
                    disableRipple: true,
                } }),
            React.createElement(SidebarItems, { linkComponent: linkComponent, menuEntries: menuList?.firstSection || [], currentServiceId: currentServiceId, customMenuForCurrentService: customMenuForCurrentService }),
            React.createElement(MenuSectionDivider, null),
            React.createElement(SidebarItems, { linkComponent: linkComponent, menuEntries: menuList?.secondSection || [], currentServiceId: currentServiceId, customMenuForCurrentService: customMenuForCurrentService }),
            React.createElement(MenuSectionDivider, null),
            React.createElement(SidebarItems, { linkComponent: linkComponent, menuEntries: menuList?.restMatched || [], currentServiceId: currentServiceId, customMenuForCurrentService: customMenuForCurrentService })),
        footerMenu && React.createElement(SidebarSection, null, footerMenu)));
};
export default memo(GlobalSidebar);
//# sourceMappingURL=GlobalSidebar.js.map